import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useIntl } from 'react-intl';

import { PrepopulatePermissions } from '../../../../../../interfaces/PrepopulatePermissions';

interface FixedFieldsProps {
  permissions: PrepopulatePermissions;
}

const FixedFields = ({ permissions }: FixedFieldsProps) => {
  const intl = useIntl();
  const fieldStyles = {
    height: '46px',
    marginTop: '12px',
    borderRadius: '6px',
    '& .MuiFilledInput-root:after': {
      border: 'none',
    },
    '& .MuiFilledInput-root:before': {
      borderBottom: 'none',
    },
    '& .MuiFilledInput-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.0275)',
    },
    '& .MuiFilledInput-root:hover:not(.Mui-disabled,.Mui-error):before': {
      borderBottom: 'none',
    },
    opacity: 0.75,
  };

  const inputStyles = {
    height: '3.5rem',
    overflow: 'hidden',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    border: '',
    borderRadius: '6px',
  };

  const CaseManagerField = () => (
    <TextField
      fullWidth
      hiddenLabel
      id='case-manager'
      type='search'
      variant='filled'
      placeholder={intl.formatMessage({ defaultMessage: 'Case Manager Name' })}
      sx={fieldStyles}
      InputProps={{
        style: inputStyles,
        disableUnderline: true,
      }}
      disabled
    />
  );

  const DateReceivedField = () => (
    <TextField
      fullWidth
      hiddenLabel
      id='date-received'
      type='search'
      variant='filled'
      placeholder={intl.formatMessage({ defaultMessage: 'Date Received' })}
      sx={fieldStyles}
      InputProps={{
        style: inputStyles,
        disableUnderline: true,
        endAdornment: <CalendarTodayOutlinedIcon />,
      }}
      disabled
    />
  );

  const ReportTypeDropdown = () => (
    <TextField
      fullWidth
      hiddenLabel
      id='report-type'
      type='search'
      variant='filled'
      placeholder={intl.formatMessage({ defaultMessage: 'Report Type' })}
      sx={fieldStyles}
      InputProps={{
        style: inputStyles,
        disableUnderline: true,
        endAdornment: <KeyboardArrowDownIcon />,
      }}
      disabled
    />
  );

  const ReportReferenceDropdown = () => (
    <TextField
      fullWidth
      hiddenLabel
      id='report-reference'
      type='search'
      variant='filled'
      placeholder={intl.formatMessage({ defaultMessage: 'Report Reference' })}
      sx={fieldStyles}
      InputProps={{
        style: inputStyles,
        disableUnderline: true,
        endAdornment: <KeyboardArrowDownIcon />,
      }}
      disabled
    />
  );

  const ReportSeverityDropdown = () => (
    <TextField
      fullWidth
      hiddenLabel
      id='report-severity'
      type='search'
      variant='filled'
      placeholder={intl.formatMessage({ defaultMessage: 'Report Severity' })}
      sx={fieldStyles}
      InputProps={{
        style: inputStyles,
        disableUnderline: true,
        endAdornment: <KeyboardArrowDownIcon />,
      }}
      disabled
    />
  );

  return (
    <Grid container padding='24px 0px' spacing={1}>
      {permissions.caseManager && (
        <Grid item xs={12} sm={6}>
          <CaseManagerField />
        </Grid>
      )}
      {permissions.dateReceived && (
        <Grid item xs={12} sm={6}>
          <DateReceivedField />
        </Grid>
      )}
      {permissions.reportType && (
        <Grid item xs={12} sm={4}>
          <ReportTypeDropdown />
        </Grid>
      )}
      {permissions.reportReference && (
        <Grid item xs={12} sm={4}>
          <ReportReferenceDropdown />
        </Grid>
      )}
      {permissions.reportSeverity && (
        <Grid item xs={12} sm={4}>
          <ReportSeverityDropdown />
        </Grid>
      )}
    </Grid>
  );
};

export default FixedFields;
